import {Box, Heading, Hr} from '@constellation/core';
import {memo, useEffect} from 'react';
import {type quoteResponseProps} from '../../../../types/cardPaymentServiceDetails.js';
import {getPsrLabel} from '../../../../utils/index.js';
import {
  sessionStorageGetItem,
  WebStorageProperties,
} from '../../../../utils/session.js';
import JourneyHeader from '../../../common/JourneyHeader/JourneyHeader.js';
import CallToAction from './CallToAction/CallToAction.js';
import CallToActionGuideLine from './CallToAction/CallToActionGuideLine.js';
import Download from './Download/Download.js';
import Example from './Example/Example.js';
import Footnotes from './Footnotes/Footnotes.js';
import OtherSection from './OtherSection/OtherSection.js';
import OutputHeader from './OutputHeader/OutputHeader.js';
import ReturnButton from './ReturnButton/ReturnButton.js';
import TransactionCharges from './TransactionCharges/TransactionCharges.js';

const {features} = window.frameworkGlobals.envConfig;

const CardPaymentServicesDetails = memo(() => {
  const quoteResponse: quoteResponseProps | string = sessionStorageGetItem(
    WebStorageProperties.QuoteResponse
  );

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  const quoteResponseObj =
    typeof quoteResponse === 'string'
      ? ({} as quoteResponseProps)
      : quoteResponse;
  const quoteID = Object.keys(quoteResponseObj).length
    ? quoteResponseObj.quote.quoteReference
    : getPsrLabel('cardPaymentServicesDetails.notApplicable');

  return (
    <Box bgColor='neutral2' marginBottom='none'>
      <JourneyHeader
        header={getPsrLabel('cardPaymentServicesDetails.journeyHeader.header')}
        serviceName={getPsrLabel(
          'cardPaymentServicesDetails.journeyHeader.serviceName'
        )}
        stepCounter={getPsrLabel(
          'cardPaymentServicesDetails.journeyHeader.stepCounter'
        )}
      />
      {features.quoteIdEnable && (
        <Heading as='h2' color='brand' size='s5'>
          {getPsrLabel('cardPaymentServicesDetails.quoteReference.label')}{' '}
          {quoteID}
        </Heading>
      )}
      <OutputHeader />
      <TransactionCharges quoteResponse={quoteResponseObj} />
      <Example quoteResponse={quoteResponseObj} />
      <OtherSection quoteResponse={quoteResponseObj} />
      <Hr marginBottom='05' marginTop='none' />
      <Footnotes />
      {features.downloadButtonEnable ? (
        <Download quoteResponse={quoteResponseObj} />
      ) : null}

      {features.callToActionGuideLineEnable ? <CallToActionGuideLine /> : null}
      {features.callToActionApplyEnable ? <CallToAction /> : null}
      <ReturnButton />
    </Box>
  );
});

export default CardPaymentServicesDetails;
